import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Tab from './ClaimBusinessRequestTab';
import Form from './ClaimBusinessRequestForm';

function ClaimBusinessRequestRouter() {
  return (
    <Switch>
      <Route exact path="/claim-business/request" component={Tab} />
      <Route exact path="/claim-business/request/:id" component={Form} />
      <Redirect to="/claim-business/request" />
    </Switch>
  );
}

export default ClaimBusinessRequestRouter;



// WEBPACK FOOTER //
// ./src/containers/ClaimBusiness/index.js